var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LogInAs',{attrs:{"athleteId":_vm.athleteId,"athleteName":_vm.userFullName}},[_c('PrimaryAction',{attrs:{"icon":"sr-2 sr-v2-login","text":"Log In as Athlete"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }